import type { StrictPopupProps } from 'semantic-ui-react';
import { Popup } from 'semantic-ui-react';
import type { FunctionalComponent } from 'apps/core/types/global.types';

export type GenericPopupProps = { onClick?: VoidFunction } & StrictPopupProps;

const GenericPopup: FunctionalComponent<GenericPopupProps> = ({
  children,
  content,
  trigger,
  position,
  size = 'tiny',
  hoverable = true,
  basic,
  onClick,
  flowing,
  hideOnScroll = true,
  style,
  header,
  inverted = true,
}) => (
  <Popup
    content={content}
    position={position}
    trigger={trigger}
    hoverable={hoverable}
    basic={basic}
    onClick={onClick}
    flowing={flowing}
    hideOnScroll={hideOnScroll}
    style={style}
    inverted={inverted}
    size={size}
    header={header}
  >
    {children}
  </Popup>
);

export default GenericPopup;
